import React, { Children, PropsWithChildren } from 'react';

import { Box, Divider } from '@mui/material';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
export interface StatusBarContainerProps {
    focused?: boolean;
}

const StatusBarContainer = ({
    focused,
    children,
}: PropsWithChildren<StatusBarContainerProps>) => {
    const { theme } = useTheme();
    const childrenArray = React.Children.toArray(children).filter(Boolean);
    return (
        <Box
            borderRadius={1}
            sx={{
                backgroundColor: focused ? 'action.hover' : 'background.paper',
                px: theme.spacing(1),
                py: theme.spacing(1),
            }}>
            <Box display="flex">
                {Children?.map(childrenArray, (child, index) => {
                    return index === 0 ? (
                        child
                    ) : (
                        <>
                            <Box display="flex" alignItems="center">
                                <Divider
                                    data-testid="status-bar-divider"
                                    sx={{ mx: 1 }}
                                    orientation="vertical"
                                    variant="middle"
                                />
                            </Box>
                            {child}
                        </>
                    );
                })}
            </Box>
        </Box>
    );
};

export default StatusBarContainer;
